import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { DaProgressiveImageOptionsInterface } from '../da-progressive-image';
import { ComponentInterface } from '@uniprank/ngx-lazy-bind';
import { SingleStageInterface } from './shared/interfaces/single-stage.interface';

@Component({
    selector: 'da-single-stage',
    templateUrl: './single-stage.component.html',
    styleUrls: ['./single-stage.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SingleStageComponent implements ComponentInterface<SingleStageInterface> {
    @Input() set data(value: SingleStageInterface) {
        if (value != null) {
            this.progressiveImageOptions = {
                alt: value.image && value.image.altText ? value.image.altText : '',
                aspectRatios: [
                    {
                        breakpoint: 360,
                        width: 480,
                        height: 360,
                        akamaiImage: value.mobileImage && value.mobileImage.imageUrl ? value.mobileImage.imageUrl : ''
                    },
                    {
                        breakpoint: 480,
                        width: 768,
                        height: 576,
                        akamaiImage: value.mobileImage && value.mobileImage.imageUrl ? value.mobileImage.imageUrl : ''
                    },
                    {
                        breakpoint: 768,
                        width: 960,
                        height: 720,
                        akamaiImage: value.mobileImage && value.mobileImage.imageUrl ? value.mobileImage.imageUrl : ''
                    },
                    {
                        breakpoint: 960,
                        width: 1120,
                        height: 420,
                        akamaiImage: value.image && value.image.imageUrl ? value.image.imageUrl : ''
                    },
                    {
                        breakpoint: 1120,
                        width: 1600,
                        height: 600,
                        akamaiImage: value.image && value.image.imageUrl ? value.image.imageUrl : ''
                    },
                    {
                        breakpoint: 1600,
                        width: 1920,
                        height: 720,
                        akamaiImage: value.image && value.image.imageUrl ? value.image.imageUrl : ''
                    }
                ]
            };
            this._data = value;
        }
    }
    get data(): SingleStageInterface {
        return this._data;
    }

    public progressiveImageOptions: DaProgressiveImageOptionsInterface;

    private _data: SingleStageInterface;

    constructor() {}
}
